import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransitionGroup } from 'react-transition-group';
import { connect } from "react-redux";

import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import 'webrtc-adapter';
import RecordRTC from 'recordrtc';

// Required imports when recording audio-only using the videojs-wavesurfer plugin
import WaveSurfer from 'wavesurfer.js';
import MicrophonePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.microphone.js';
WaveSurfer.microphone = MicrophonePlugin;

// Register videojs-wavesurfer plugin
import 'videojs-wavesurfer/dist/css/videojs.wavesurfer.css';
import Wavesurfer from 'videojs-wavesurfer/dist/videojs.wavesurfer.js';

// register videojs-record plugin with this import
import 'videojs-record/dist/css/videojs.record.css';
import Record from 'videojs-record/dist/videojs.record.js';

import 'videojs-record/dist/plugins/videojs.record.lamejs.js';

class AudioRecord extends Component {
  constructor(props) {
    super(props);
    this.state = { };
    this.videoJsOptions = {
      controls: true,
      height: 240,
      fluid: false,
      plugins: {
        // wavesurfer section is only needed when recording audio-only
        wavesurfer: {
          src: 'live',
          waveColor: '#6F95E7',
          progressColor: 'black',
          debug: true,
          cursorWidth: 1,
          msDisplayMax: 20,
          hideScrollbar: true
        },
        record: {
          audio: true,
          video: false,
          maxLength: 20,
          debug: true,
          audioEngine: 'lamejs',
          audioWorkerURL: '/worker-realtime.js',
          audioSampleRate: 44100,
          audioBitRate: 128
        }
      }
    };
  }


  componentDidMount() {
      // instantiate Video.js
      this.player = videojs(this.videoNode, this.videoJsOptions, () => {
        // print version information at startup
        var version_info = 'Using video.js ' + videojs.VERSION +
            ' with videojs-record ' + videojs.getPluginVersion('record') +
            ' and recordrtc ' + RecordRTC.version;
        videojs.log(version_info);
      });

      // device is ready
      this.player.on('deviceReady', () => {
        console.log('device is ready!');
      });

      // user clicked the record button and started recording
      this.player.on('startRecord', () => {
        console.log('started recording!');
      });

      // user completed recording and stream is available
      this.player.on('finishRecord', () => {
        // recordedData is a blob object containing the recorded data that
        // can be downloaded by the user, stored on server etc.
        console.log('finished recording: ', this.player.recordedData);
        // this.finishRecord(this.player.recordedData);
        this.props.handleFinishRecord(this.player.recordedData);
      });

      // error handling
      this.player.on('error', (element, error) => {
        console.warn(error);
      });

      this.player.on('deviceError', () => {
        console.error('device error:', this.player.deviceErrorCode);
      });
  }

  // destroy player on unmount
  componentWillUnmount() {
      if (this.player) {
          this.player.dispose();
      }
  }

  render() {
      return (
      <div data-vjs-player>
        <video
          id="RecordAudio"
          ref={node => this.videoNode = node}
          className="video-js vjs-default-skin"
          playsInline
        >
        </video>
      </div>
      );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { }
)(AudioRecord);
